import { api } from 'agent';
import { CommentDTO } from './dto/CommentDTO';

export function getCommentsByUploadId(uploadId: number): Promise<CommentDTO[]> {
  return api.get(`comment/${uploadId}`).then((response: { data: CommentDTO[] }) => response.data);
}

export function countCommentsByUploadId(uploadId: number): Promise<number> {
  return api.get(`comment/count/${uploadId}`).then((response: { data: number }) => response.data);
}

export function postComment(comment: CommentDTO): Promise<void> {
  return api.post(`comment/${comment.uploadId}`, comment.comment);
}
